var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodaysLate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning Circle Icon 1",
    clipPath: "url(#clip0_531_18956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0C31.04 0 40 8.96 40 20C40 31.04 31.04 40 20 40C8.96 40 0 31.04 0 20C0 8.96 8.96 0 20 0ZM20 2.668C10.444 2.668 2.668 10.444 2.668 20C2.668 29.556 10.444 37.332 20 37.332C29.556 37.332 37.332 29.556 37.332 20C37.332 10.444 29.556 2.668 20 2.668Z",
    fill: "#5E718D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.0124 9.95198L21.1084 10.096L21.1964 10.248L30.3964 27.196C31.0284 28.36 30.5204 29.316 29.2644 29.396L29.0884 29.4H10.9124C9.58838 29.4 8.99638 28.496 9.52838 27.352L9.60438 27.196L18.8044 10.248C19.4044 9.13598 20.3484 9.03998 21.0124 9.95198ZM20.0004 24.128L19.8604 24.136C19.2644 24.2 18.7924 24.66 18.7204 25.236L18.7124 25.384L18.7204 25.52C18.7844 26.104 19.2564 26.564 19.8484 26.632L20.0004 26.64L20.1404 26.632C20.7364 26.572 21.2084 26.112 21.2804 25.532L21.2884 25.384L21.2804 25.248C21.2164 24.668 20.7444 24.204 20.1524 24.136L20.0004 24.128ZM20.0004 14.076L19.8604 14.084C19.2644 14.148 18.7924 14.608 18.7204 15.188L18.7124 15.332V21.616C18.7124 22.264 19.2164 22.796 19.8604 22.864L20.0004 22.872L20.1404 22.864C20.7364 22.8 21.2084 22.344 21.2804 21.764L21.2884 21.616V15.332C21.2884 14.64 20.7124 14.076 20.0004 14.076Z",
    fill: "#5E718D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_18956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodaysLate);
export default __webpack_public_path__ + "static/media/Today’s Late.8fec26ffa99f62486b8b1efd16521980.svg";
export { ForwardRef as ReactComponent };